import styled from "styled-components";

export const SectionIndicator = styled.div`
  border-radius: 30px;
  color: var(--heighlight-color);
  font-size: 0.6em;
  background: #dcfce7;
  padding: 0.5px 7px;
`;
